import axios from "../plugins/parseAxios";
export class PasswordRecoveryAPI {
  constructor(props) { }
  static getPasswordRecovery(payload) {
    return axios.post("functions/getPasswordRecovery", payload);
  }
  static createPasswordRecovery(payload) {
    return axios.post("functions/createPasswordRecovery", payload);
  }
  static checkPasswordRecovery(payload) {
    return axios.post("functions/checkPasswordRecovery", payload);
  }
  static changePasswordRecovery(payload) {
    return axios.post("functions/changePasswordRecovery", payload);
  }

}
